import * as dragonBones from "./libs/dragonBones";

export function createArmatureFromSkeleton(resources) {
  const factory = dragonBones.PixiFactory.factory;
  factory.parseDragonBonesData(resources.skeleton.data);
  factory.parseTextureAtlasData(
    resources.texture_atlas.data,
    resources.texture_png.texture
  );
  const armatureDisplay = factory.buildArmatureDisplay("Armature");
  return armatureDisplay;
}

export function setupZach(armature, app) {
  armature.animation.play("idle");
  app.stage.addChild(armature);
  armature.x = app.screen.width / 2;
  armature.y = app.screen.height / 2;

  app.renderer.plugins.interaction.on("pointerdown", (e) => {
    armature.animation.play("run");
  });
  app.renderer.plugins.interaction.on("pointerup", (e) => {
    armature.animation.play("idle");
  });

  return armature;
}
